export default __webpack_public_path__ + "static/media/vehicle_active_passenger.bb5d3e2d.svg";